import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'react-responsive-modal/styles.css';
import * as Sentry from '@sentry/react';

const sentryEnabled = !process.env.REACT_APP_DISABLE_SENTRY;

Sentry.init({
  dsn: sentryEnabled ? process.env.REACT_APP_SENTRY_DNS : undefined,
  enabled: sentryEnabled,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/dev-simulateurb2c\.hellio\.com\/simulateurb2c/,
    /^https:\/\/staging-simulateurb2c\.hellio\.com\/simulateurb2c/,
    /^https:\/\/api-simulateurb2c\.hellio\.com\/simulateurb2c/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// import your route components too
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Routes>
      <Route index element={<App />} />
      <Route path="*" element={<App />}></Route>
      {/* <Route path="*" element={<App id='Q1' />} /> */}
    </Routes>
  </BrowserRouter>,
);
